import { render } from "./CategoriasList.vue?vue&type=template&id=11d3193c&scoped=true"
import script from "./CategoriasList.vue?vue&type=script&lang=js"
export * from "./CategoriasList.vue?vue&type=script&lang=js"

import "./CategoriasList.vue?vue&type=style&index=0&id=11d3193c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11d3193c"]])

export default __exports__